import { WorkflowModel } from '@em/models/restapi/Workflow.Model';
import { CollectionModel } from '@shared/models/restapi/Collection.Model';

export class WorkflowCollectionModel extends CollectionModel<WorkflowModel> {
    public constructor() {
        super(WorkflowModel);
    }
}
